/*@flow*/
/** @jsx jsx */
import { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import usePrev from 'lib/usePrev';
import useThemeColor from './useThemeColor';

function Spinner() {
  return <i className="fa fa-compass fa-spin" />;
}

function MemberFormSubmitBtn({
  onClick,
  children,
  isLoading,
  disabled,
  width,
}: {
  onClick?: () => any,
  children: React$Node,
  isLoading?: boolean,
  disabled?: boolean,
  width?: string,
}) {
  const [isReady, setReady] = useState(true);
  const { data: themeColor, loading } = useThemeColor();

  const content = !isLoading && isReady ? children : <Spinner />;
  const prevLoading = usePrev(isLoading);

  useEffect(() => {
    if (prevLoading !== true || isLoading !== false) return;
    setReady(false);
    setTimeout(() => {
      setReady(true);
    }, 200);
  }, [isLoading, prevLoading]);

  if (loading) {
    return <div css={css('width: 100px; height: 3rem; background: #ddd;')} />;
  }

  return (
    <button
      data-testid="MemberFormSubmitBtn"
      type="submit"
      className="btn rounded btn-notransform pb-2"
      css={css(`
        transition: width 300ms;
        width: ${isLoading ? '40px' : width || '100%'};
        background-color: ${themeColor};
        color: white;
        &:hover {
          color: white;
        }
      `)}
      disabled={isLoading || disabled}
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick();
      }}
    >
      {content}
    </button>
  );
}

export default (MemberFormSubmitBtn: any);
